import { useConnectModal } from '@rainbow-me/rainbowkit';

export const useHandleConnectClick = () => {
  const { openConnectModal } = useConnectModal();

  const handleConnectClick = () => {
    if (openConnectModal) {
      openConnectModal();
    }
  };

  return { handleConnectClick };
};
